import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API_URL } from "../../../apiConfig";

const Createcoup = () => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    discountAmount: "",
    createdBy: sessionStorage.getItem("adminname") || "",
    planId: "",
    couponPlanId: "",
    expiryDate: "",
    token: "",
  });
  const [coupons, setCoupons] = useState([]);
  const [mainPlans, setMainPlans] = useState([]);
  const [couponPlans, setCouponPlans] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [mainPlanPrice, setMainPlanPrice] = useState(0);
  const [couponPlanPrice, setCouponPlanPrice] = useState(0);
  const [editCouponId, setEditCouponId] = useState(null);

  const fetchMainPlans = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/v1/plan/plans`, {
        withCredentials: true,
      });
      if (response.data.success && Array.isArray(response.data.data.plans)) {
        setMainPlans(response.data.data.plans);
      }
    } catch (error) {
      console.error(
        "Error fetching main plans:",
        error.response?.data || error
      );
      setMainPlans([]);
    }
  }, []);

  const fetchCouponPlans = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/v1/admin/plans`, {
        withCredentials: true,
      });
      if (response.data.success && Array.isArray(response.data.data)) {
        setCouponPlans(response.data.data);
      }
    } catch (error) {
      console.error(
        "Error fetching coupon plans:",
        error.response?.data || error
      );
      setCouponPlans([]);
    }
  }, []);

  const fetchCoupons = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/v1/coupon/coupons`, {
        withCredentials: true,
      });
      if (response.data.success && Array.isArray(response.data.data)) {
        setCoupons(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching coupons:", error.response?.data || error);
      setCoupons([]);
    }
  }, []);

  useEffect(() => {
    fetchMainPlans();
    fetchCouponPlans();
    fetchCoupons();
  }, [fetchMainPlans, fetchCouponPlans, fetchCoupons]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "token") {
      if (!/^[A-Z0-9]*$/.test(value)) {
        alert(
          "Token must contain only capital letters (A-Z) with no special characters"
        );
        return;
      }
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMainPlanSelect = (planId) => {
    const selected = mainPlans.find((plan) => plan.planId === planId);
    console.log("ll", selected?.rp_plan_id);
    const selectedPrice = selected?.plan_price || 0;
    const discount =
      selectedPrice - couponPlanPrice > 0 ? selectedPrice - couponPlanPrice : 0;

    setMainPlanPrice(selectedPrice);
    setSelectedPlan(planId);
    setFormData((prev) => ({
      ...prev,
      planId: selected?.rp_plan_id || "",
      discountAmount: discount.toString(),
    }));
  };

  const handleCouponPlanSelect = (planId) => {
    const selected = couponPlans.find((plan) => plan.planId === planId);
    const selectedPrice = selected?.planPrice || 0;
    const discount =
      mainPlanPrice - selectedPrice > 0 ? mainPlanPrice - selectedPrice : 0;

    setCouponPlanPrice(selectedPrice);
    setFormData((prev) => ({
      ...prev,
      couponPlanId: selected?.rpPlanId || "",
      discountAmount: discount.toString(),
    }));
  };

  const handleEdit = (coupon) => {
    setIsEditMode(true);
    setEditCouponId(coupon._id);
    setFormData({
      name: coupon.name,
      description: coupon.description,
      discountAmount: coupon.discountAmount.toString(),
      createdBy: coupon.createdBy,
      planId: coupon.planId,
      couponPlanId: coupon.couponPlanId || "",
      expiryDate: coupon.expiryDate.split("T")[0], // Format for date input
      token: coupon.token,
    });
    setMainPlanPrice(
      mainPlans.find((p) => p.planId === coupon.planId)?.plan_price || 0
    );
    setCouponPlanPrice(
      couponPlans.find((p) => p.planId === coupon.couponPlanId)?.planPrice || 0
    );
    setSelectedPlan(coupon.planId);
    setIsModalOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this coupon?")) {
      try {
        const response = await axios.delete(
          `${API_URL}/api/v1/coupon/delete-coupon?id=${id}`,
          {
            withCredentials: true,
          }
        );
        if (response.status === 200) {
          alert("Coupon deleted successfully!");
          fetchCoupons();
        }
      } catch (error) {
        console.error("Error deleting coupon:", error.response?.data || error);
        alert("Failed to delete coupon");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.token.match(/^[A-Z0-9]+$/)) {
      alert("Token must contain only capital letters and cannot be empty");
      return;
    }
    try {
      const url = isEditMode
        ? `${API_URL}/api/v1/coupon/update-coupon?id=${editCouponId}`
        : `${API_URL}/api/v1/coupon/create-coupon`;
      const method = isEditMode ? "put" : "post";

      const response = await axios({
        method,
        url,
        data: formData,
        withCredentials: true,
        headers: { "Content-Type": "application/json" },
      });

      if (response.status === 201 || response.status === 200) {
        alert(`Coupon ${isEditMode ? "updated" : "created"} successfully!`);
        setFormData({
          name: "",
          description: "",
          discountAmount: "",
          createdBy: sessionStorage.getItem("adminname") || "",
          planId: "",
          couponPlanId: "",
          expiryDate: "",
          token: "",
        });
        setIsModalOpen(false);
        setIsEditMode(false);
        setEditCouponId(null);
        setSelectedPlan(null);
        setMainPlanPrice(0);
        setCouponPlanPrice(0);
        fetchCoupons();
      }
    } catch (error) {
      console.error(
        `Error ${isEditMode ? "updating" : "creating"} coupon:`,
        error.response?.data || error
      );
      alert(`Failed to ${isEditMode ? "update" : "create"} coupon`);
    }
  };

  return (
    <div className="p-4 sm:p-6 max-w-7xl mx-auto">
      <div className="flex flex-col sm:flex-row justify-between items-center mb-6 gap-4">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-800">
          Coupon List
        </h2>
        <button
          onClick={() => {
            setIsEditMode(false);
            setIsModalOpen(true);
          }}
          className="w-full sm:w-auto bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition"
        >
          Add Coupon
        </button>
      </div>

      <div className="bg-white shadow-md rounded-lg overflow-hidden">
        {coupons.length === 0 ? (
          <p className="p-4 text-gray-500 text-center">No coupons available.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  {[
                    "Name",
                    "Description",
                    "Discount",
                    "Created By",
                    "Plan ID",
                    "Coupon Plan ID",
                    "Token",
                    "Expiry Date",
                    // "Created At",
                    // "Updated At",
                    "Actions",
                  ].map((header) => (
                    <th
                      key={header}
                      className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden sm:table-cell"
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {coupons.map((coupon) => (
                  <tr
                    key={coupon._id}
                    className="hover:bg-gray-50 flex flex-col sm:table-row"
                  >
                    <td className="px-2 py-4 text-sm text-gray-900 sm:whitespace-nowrap block sm:table-cell">
                      <span className="sm:hidden font-bold">Name: </span>
                      {coupon.name}
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 max-w-xs break-words block sm:table-cell">
                      <span className="sm:hidden font-bold">Description: </span>
                      {coupon.description}
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 sm:whitespace-nowrap block sm:table-cell">
                      <span className="sm:hidden font-bold">Discount: </span>
                      {coupon.discountAmount}
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 sm:whitespace-nowrap block sm:table-cell">
                      <span className="sm:hidden font-bold">Created By: </span>
                      {coupon.createdBy}
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 sm:whitespace-nowrap block sm:table-cell">
                      <span className="sm:hidden font-bold">Plan ID: </span>
                      {coupon.planId}
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 sm:whitespace-nowrap block sm:table-cell">
                      <span className="sm:hidden font-bold">
                        Coupon Plan ID:{" "}
                      </span>
                      {coupon.couponPlanId || "N/A"}
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 sm:whitespace-nowrap block sm:table-cell">
                      <span className="sm:hidden font-bold">Token: </span>
                      {coupon.token || "N/A"}
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 sm:whitespace-nowrap block sm:table-cell">
                      <span className="sm:hidden font-bold">Expiry: </span>
                      {new Date(coupon.expiryDate).toLocaleDateString()}
                    </td>
                    {/* <td className="px-2 py-4 text-sm text-gray-900 sm:whitespace-nowrap block sm:table-cell">
                      <span className="sm:hidden font-bold">Created: </span>
                      {new Date(coupon.createdAt).toLocaleString()}
                    </td>
                    <td className="px-2 py-4 text-sm text-gray-900 sm:whitespace-nowrap block sm:table-cell">
                      <span className="sm:hidden font-bold">Updated: </span>
                      {new Date(coupon.updatedAt).toLocaleString()}
                    </td> */}
                    <td className="px-2 py-4 text-sm text-gray-900 block sm:table-cell">
                      <span className="sm:hidden font-bold">Actions: </span>
                      <div className="flex gap-2">
                        <button
                          onClick={() => handleEdit(coupon)}
                          className="bg-yellow-500 text-white px-2 py-1 rounded hover:bg-yellow-600 transition"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDelete(coupon._id)}
                          className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600 transition"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white p-6 rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-6">
              {isEditMode ? "Edit Coupon" : "Add New Coupon"}
            </h3>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Select Main Plan
              </label>
              <select
                onChange={(e) => handleMainPlanSelect(e.target.value)}
                value={
                  mainPlans.find((p) => p.rp_plan_id === formData.planId)
                    ?.planId || ""
                }
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white shadow-sm"
              >
                <option value="">-- Select a Main Plan --</option>
                {mainPlans.map((plan) => (
                  <option key={plan.planId} value={plan.planId}>
                    {plan.plan_name} - {plan.plan_subtext} (₹{plan.plan_price})
                  </option>
                ))}
              </select>
            </div>

            {selectedPlan && (
              <>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Select Coupon Plan
                  </label>
                  <select
                    onChange={(e) => handleCouponPlanSelect(e.target.value)}
                    value={
                      couponPlans.find(
                        (p) => p.rpPlanId === formData.couponPlanId
                      )?.planId || ""
                    }
                    className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white shadow-sm"
                  >
                    <option value="">-- Select a Coupon Plan --</option>
                    {couponPlans.map((plan) => (
                      <option key={plan.planId} value={plan.planId}>
                        {plan.planName} - {plan.planSubtext} (₹{plan.planPrice})
                      </option>
                    ))}
                  </select>
                </div>

                <form
                  onSubmit={handleSubmit}
                  className="grid grid-cols-1 sm:grid-cols-2 gap-4"
                >
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Description
                    </label>
                    <input
                      type="text"
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                      required
                      className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Discount Amount
                    </label>
                    <input
                      type="number"
                      name="discountAmount"
                      value={formData.discountAmount}
                      readOnly
                      className="w-full p-3 border border-gray-300 rounded-md bg-gray-100 shadow-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Created By
                    </label>
                    <input
                      type="text"
                      name="createdBy"
                      value={formData.createdBy}
                      readOnly
                      className="w-full p-3 border border-gray-300 rounded-md bg-gray-100 shadow-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Main Plan ID (Razorpay)
                    </label>
                    <input
                      type="text"
                      name="planId"
                      value={formData.planId}
                      readOnly
                      className="w-full p-3 border border-gray-300 rounded-md bg-gray-100 shadow-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Coupon Plan ID (Razorpay)
                    </label>
                    <input
                      type="text"
                      name="couponPlanId"
                      value={formData.couponPlanId}
                      readOnly
                      className="w-full p-3 border border-gray-300 rounded-md bg-gray-100 shadow-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Token (Capital Letters Only)
                    </label>
                    <input
                      type="text"
                      name="token"
                      value={formData.token}
                      onChange={handleChange}
                      required
                      className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
                    />
                  </div>
                  <div className="sm:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Expiry Date
                    </label>
                    <input
                      type="date"
                      name="expiryDate"
                      value={formData.expiryDate}
                      onChange={handleChange}
                      required
                      className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
                    />
                  </div>
                  <div className="sm:col-span-2 flex justify-end space-x-3 mt-4">
                    <button
                      type="button"
                      onClick={() => {
                        setIsModalOpen(false);
                        setIsEditMode(false);
                        setEditCouponId(null);
                        setSelectedPlan(null);
                      }}
                      className="w-full sm:w-auto px-5 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 transition shadow-sm"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="w-full sm:w-auto px-5 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition shadow-sm"
                    >
                      {isEditMode ? "Update Coupon" : "Create Coupon"}
                    </button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Createcoup;
